import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-rating-lookup',
  templateUrl: './micro-rating-lookup.component.html'
})
export class MicroRatingLookupComponent  {

  @Input()
  ratingId:any;

  @Input()
  link:boolean = true;
}
